<template>
        <!-- Options Modal -->
        <Modal :open="options_modal_open" @close="setModalOpen(false)">
            <div slot="header">
                Note Options
            </div>

            <div slot="body" id="options-body">
                <div id="aliases-section" class="options-section">
                    <span class="section-label">Aliases</span>
                    
                    <div id="alias-adder">
                        <input id="alias-input" type="text" v-model="new_alias" placeholder="Write your new alias"/>
                        <i class="fas fa-plus flat-icon-button" id="add-button" @click="addAlias" title="Click to add your new alias"/>
                    </div>

                    <div v-for="(alias, index) in note_aliases" :key="'alias-'+ alias" class="alias-row">
                        <span class="alias-name">"{{ alias }}"</span>
                        <i class="fas fa-minus flat-icon-button" @click.stop="deleteAlias(index)"/>
                    </div>
                </div>

                <!-- Folder section coming soon -->
                <div id="folder-section" class="options-section">
                    <span class="section-label">Folder</span>
                    <dropdown :options="folder_options" v-model="parent_slug"/>
                </div>

                <span class="settings-button-row">
                    <i class="action icon-button sized danger clickable fas fa-2x fa-trash-alt "  id="edit" @click="deleteNote"/>
                </span>
            </div>

            <div v-if="note_alias_error" slot="footer" class="alias-error">
                {{ note_alias_error }}
            </div>
        </Modal>
</template>

<script>
import Dropdown from '../Dropdown.vue'
import Modal from '../Modal.vue'
import _ from 'lodash';
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export default {
    components: { Modal, Dropdown },
    props: [],
    data(){
        return{
            new_alias: '',
            note_alias_error: null,
            show_header: false
        }
    },

    methods:{
        deleteNote() {
            this.$store.dispatch('deleteNoteFromWorkspace', this.note).then(() => {
                this.$router.replace('/')
            });
        },

        setModalOpen(value = null, event) {
            this.$store.commit('setNoteOptionsVisible', value);
        },
        
        addAlias() {
            this.note_aliases= [...(this.note_aliases||[]), this.new_alias];
        },

        deleteAlias(index) {
            this.note_aliases.splice(index, 1);
        },

       
    },

    watch: {
        new_alias() {
            this.note_alias_error = null;
        }
    },


    computed : {
        folder_options() {
            return this.folders.map(folder =>( {label: folder.name, key: folder.slug}));
        },

        note(){
            return this.$store.getters.note_by_slug(this.$route.params.note_route);
        },

        current_workspace() {
            return this.$store.getters.current_workspace;
        },

        folders() {
            return Object.values(this.$store.getters.folders);
        },

        current_note() {
            return this.$store.getters.current_note;
        },

        parent_slug: {
            get() {
                return this.note.parent_slug;
            },

            set(val) {
                this.$store.dispatch('updateNote', {...this.note, parent_slug: val});
            }
        },

        parent_folder() {
            return this.$store.getters.folders[this.note.parent_slug];
        },

        note_aliases: {
            get: function() {
                let value = this.current_note && this.current_note.aliases ? this.current_note.aliases : [];
                return value
            },

            set: _.debounce(function(val) {
                this.$store.dispatch('updateNote', {...this.note, aliases: val});
            }, 300)
            
        },
        
        options_modal_open() {
            return this.$store.getters.note_options_visible;
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../../assets/colors.sass";
    
    
    i.icon-button.action
        margin: 0px 5px
        
    .settings-button-row
        width: 100%
        text-align: left
        margin-left: -25px;
        margin-bottom: -15px;
        margin-top: 15px;


    // Options Modal
    #options-body
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        padding: 20px;
        padding-bottom: 25px;
        padding-top: 0px;

    .options-section
        display: flex;
        flex-direction: column;
        position: relative;
        flex: 1;
        min-width: 200px;
        
        margin: 30px 10px 0px 10px;
        padding: 15px;
        border: 1px solid $border-medium;
        border-radius: 5px;
        box-shadow: $card-shadow;

        .section-label
            position: absolute;
            bottom: calc(100% + 1px);
            left: 0;
            width: 100%;
            text-align: left;
            padding-left: 5px;
            font-size: 0.85em;
            opacity: 0.65;

    #aliases-section
        max-width: 500px
    .alias-error
        color: $red

    #alias-adder
        display: flex
        flex-direction: row
        justify-content: space-between
        margin-bottom: 5px

        input
            flex: 1
            min-width: 0
        
    .flat-icon-button
        margin-left: 5px

    .alias-row
        display: flex
        flex-direction: row
        justify-content: space-between
        
        &:not(:last-child)
            border-bottom: 1px solid transparentize($border-medium, 0.6);

        // Make sure last element is same height:
        &:last-child
            border-bottom: 1px solid transparent

        span
            flex: 1
            padding: 5px 10px
            text-align: left
            font-size: 0.9em
            font-weight: 300
            

        &:nth-child(even)
            background-color: darken($darker-bg, 7%)
</style>